import React, { Component } from 'react'
import { Card, Avatar, Spin, Form, DatePicker, Select } from 'antd';
import { connect } from 'dva'
import moment from 'moment'
import { all } from '../../services/restApi'
import { getTotal } from '../../utils'
import config from '../../utils/config'
import Currency from 'react-currency-formatter';
const _ = require('underscore')

const FormItem = Form.Item;
const Option = Select.Option;
const MonthPicker = DatePicker.MonthPicker;

class Dashboard extends Component {

    constructor (props) {
        super(props);

        this.state = {
            daily: [], 
            pending: [],
            hotels: []
        };

        if (localStorage.getItem('currentHotel')) 
            this.state = {...this.state, currentHotel: JSON.parse(localStorage.getItem('currentHotel'))};
    }


    /**
    * Inicialización
    */
    componentDidMount () {
        /*this.get_incomes();

        setInterval(() => {
            this.get_incomes();
        }, 60000);*/

        this.getHotels();
    }


    getHotels (date) {
        let query = {};
        !date ? date = new Date() : date = new Date(date);


        console.log(date);
        console.log(date.getMonth() + 1);


        if (this.props.app.user.type === 'recepcionista' || this.props.app.user.type === 'gerente') {
            query.objectId = {$in: _.pluck(this.props.app.user.hotels, 'objectId')}
        }

        this.props.dispatch({type: 'app/showLoadingTable'})

        // Consulta los hoteles
        all('Hotel', {where: query, limit: 1000, order: 'name'}).then((resp) => {

            this.setState({hotels: []});
            _.map(resp.results, (item, key) => {

                // Obtiene el total de los moviemientos en status de pendiente
                //this.get_incomes_pending(item.objectId);

                all('Report', {
                    where: {
                        hotel: {__type: 'Pointer', className: 'Hotel', objectId: item.objectId},
                        month: (date.getMonth() + 1).toString(),
                        year: (date.getFullYear()).toString()
                    }
                }).then((report) => {
                    console.log(report);

                    item.report = report.results[0];
                    this.setState({ hotels: this.state.hotels.concat([item]) });

                    if (key === resp.results.length - 1) {
                        this.props.dispatch({type: 'app/hideLoadingTable'})
                    }
                });
            });
        })
    }


    get_incomes_pending (hotelId) {
        let pending_query = {
            status: 'pending',
            hotel: {__type: 'Pointer', className: 'Hotel', objectId: hotelId},
            requestedAt: {
                $gte: {__type: 'Date', iso: new Date(moment().startOf('month').format()).toISOString()},
                $lte: {__type: 'Date', iso: new Date(moment().endOf('month').format()).toISOString()},
            }
        };

        all('Income', {
            where: pending_query,
            include: 'hotel', 
            limit: 1000, 
            count: 1, 
        }).then(resp => {
            
            let amount_expense_total = getTotal(resp.results, 'amount_expense');
            let amount_income_total = getTotal(resp.results, 'amount_income');
        })
    }


    /**
    * Render del componente
    */
    render () {

        if (this.props.app.user.type === 'administrador') {
            return (
                <div className="content-wrapper">
                    <section className="content text-center">
                        <h1>BIENVENIDO AL SISTEMA DE FACTURACIÓN<br />
                        TRIE HOTELS</h1>

                        <div className="row marginTop30">
                            <div className="col-md-4 col-md-offset-4">
                                <FormItem>
                                    {this.props.form.getFieldDecorator('requestedAt', {
                                        rules: [{
                                            required: true,
                                            message: 'Seleccione el mes',
                                        }]
                                    })(
                                        <MonthPicker onChange={(date) => this.getHotels(date)} />
                                    )}
                                </FormItem>
                            </div>
                        </div>

                        <div className="row">
                            <Spin spinning={this.props.app.loadingTable}>
                                {this.state.hotels.length > 0 && this.state.hotels.map((item) => (
                                    <div className="col-md-3 text-left" key={item.objectId}>
                                        <Card title={<span><Avatar shape="square" size="large" src={config.externalUrl + 'uploads/hotels/' + item.picture} /> {item.name}</span>} >

                                            <div className="row">
                                                <div className="col-xs-6">Ingresos:</div> 
                                                <div className="col-xs-6 text-right">
                                                    <Currency quantity={item.report ? item.report.ingresos : 0} currency="USD" />
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-xs-6">Egresos:</div> 
                                                <div className="col-xs-6 text-right">
                                                    <Currency quantity={item.report ? item.report.egresos : 0} currency="USD" />
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-xs-6">Capital entregado:</div> 
                                                <div className="col-xs-6 text-right">
                                                    <Currency quantity={item.report ? item.report.entregado : 0} currency="USD" />
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-xs-6">Total a favor:</div> 
                                                <div className="col-xs-6 text-right"><span style={{color: 'red'}}>
                                                    <Currency quantity={item.report ? item.report.total : 0} currency="USD" />
                                                </span></div>
                                            </div>

                                        </Card>,
                                    </div>
                                ))}
                            </Spin>
                        </div>

                        {/*}div className="row">
                            <div className="col-md-6">
                                <div className="box box-primary marginTop30">
                                    <div className="box-header with-border">
                                        <h3 className="box-title">Efectivo Diario</h3>
                                    </div>
                                
                                    <div className="box-body">
                                        <div className="table-responsive">
                                            <table className="table no-margin">
                                                <thead>
                                                    <tr>
                                                        <th></th>
                                                        <th className="text-left">Hotel</th>
                                                        <th className="text-center">Ingreso</th>
                                                        <th className="text-center">Egreso</th>
                                                        <th className="text-center">Total</th>
                                                    </tr>
                                                </thead>
                                                
                                                <tbody>
                                                    {this.state.daily && this.state.daily.map((item, key) => {
                                                        return (
                                                            <tr key={item.objectId}>
                                                                <td style={{width: 60}}>
                                                                    {!item.picture ?
                                                                        <Avatar size="large" src="assets/img/noimage.png" /> :
                                                                        <Avatar size="large" src={config.externalUrl + 'uploads/hotels/' + item.picture} />
                                                                    }
                                                                </td>
                                                                <td className="text-left">{item.hotel}</td>
                                                                <td><Currency quantity={item.amount_income_total ? item.amount_income_total : 0} currency="USD" /></td>
                                                                <td><Currency quantity={item.amount_expense_total ? item.amount_expense_total : 0} currency="USD" /></td>
                                                                <td><Currency quantity={item.amount_income_total - item.amount_expense_total} currency="USD" /></td>
                                                            </tr>
                                                        )
                                                    })}
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td><Currency quantity={getTotal(this.state.daily, 'amount_income_total')} currency="USD" /></td>
                                                        <td><Currency quantity={getTotal(this.state.daily, 'amount_expense_total')} currency="USD" /></td>
                                                        <td><Currency quantity={getTotal(this.state.daily, 'amount_income_total') - getTotal(this.state.daily, 'amount_expense_total')} currency="USD" /></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="box box-primary marginTop30">
                                    <div className="box-header with-border">
                                        <h3 className="box-title">Pagos por hacer</h3>
                                    </div>
                                
                                    <div className="box-body">
                                        <div className="table-responsive">
                                            <table className="table no-margin">
                                                <thead>
                                                    <tr>
                                                        <th></th>
                                                        <th className="text-left">Hotel</th>
                                                        <th className="text-center">Ingreso</th>
                                                        <th className="text-center">Egreso</th>
                                                        <th className="text-center">Total</th>
                                                    </tr>
                                                </thead>
                                                
                                                <tbody>
                                                    {this.state.pending && this.state.pending.map((item, key) => {
                                                        return (
                                                            <tr key={item.objectId}>
                                                                <td style={{width: 60}}>
                                                                    {!item.picture ?
                                                                        <Avatar size="large" src="assets/img/noimage.png" /> :
                                                                        <Avatar size="large" src={config.externalUrl + 'uploads/hotels/' + item.picture} />
                                                                    }
                                                                </td>
                                                                <td className="text-left">{item.hotel}</td>
                                                                <td><Currency quantity={item.amount_income_total ? item.amount_income_total : 0} currency="USD" /></td>
                                                                <td><Currency quantity={item.amount_expense_total ? item.amount_expense_total : 0} currency="USD" /></td>
                                                                <td><Currency quantity={item.amount_income_total - item.amount_expense_total} currency="USD" /></td>
                                                            </tr>
                                                        )
                                                    })}
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td><Currency quantity={getTotal(this.state.pending, 'amount_income_total')} currency="USD" /></td>
                                                        <td><Currency quantity={getTotal(this.state.pending, 'amount_expense_total')} currency="USD" /></td>
                                                        <td><Currency quantity={getTotal(this.state.pending, 'amount_income_total') - getTotal(this.state.pending, 'amount_expense_total')} currency="USD" /></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>*/}
                    </section>
                </div>
            )
        } else {
            return (
                <div className="content-wrapper">
                    <section className="content text-center">
                        <h1>BIENVENIDO AL SISTEMA DE FACTURACIÓN<br />
                        TRIE HOTELS</h1>
                    </section>
                </div>
            )
        }
    }
}

export default connect(({dashboard, app}) => ({dashboard, app}))(Form.create()(Dashboard))


// WEBPACK FOOTER //
// ./src/components/dashboard/index.js